export default "__VITE_ASSET__scUHqBYz__"